import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useChord } from './use-chord';
import { trackCartViewed, trackCollectionClicked, trackEmailCaptured, trackProductClicked, trackProductViewed, trackVariantClicked } from '../redux/actions/analytics';
/**
 * The `useAnalytics` hook returns a set of functions that sends events to
 * Segment.
 *
 * @example
 *
 * ```javascript
 * import { useAnalytics } from '@chordcommerce/react-autonomy'
 *
 * const ProductLink = ({ children, product }) => {
 *   const { trackProductClicked } = useAnalytics()
 *   const url = `/products/${product.slug}/`
 *
 *   return (
 *     <a href={url} onClick={() => trackProductClicked({ product })}>
 *       {children}
 *     </a>
 *   )
 * }
 * ```
 *
 * @category Hook
 */
export function useAnalytics() {
  var dispatch = useDispatch();
  var _useChord = useChord(),
    analytics = _useChord.analytics;
  var hookMethods = useMemo(function () {
    return _objectSpread({
      chordAnalytics: analytics
    }, bindActionCreators({
      trackCartViewed: trackCartViewed,
      trackCollectionClicked: trackCollectionClicked,
      trackEmailCaptured: trackEmailCaptured,
      trackProductClicked: trackProductClicked,
      trackProductViewed: trackProductViewed,
      trackVariantClicked: trackVariantClicked
    }, dispatch));
  }, [dispatch, analytics]);
  return hookMethods;
}